
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteDevices } from "../../../../../MyApi/sb/device";
import icons from "../../../../../Data/icons";

const SingleDevice = ({ Device, classes , refetch}) => {
  const { id,name,mac,uuid,major,status,sb_company_id,sb_branch_id,company,branch } = Device;

  const navigate = useNavigate()

  const EditPen = icons.pen
  const mutation =useMutation(["deleteDevices" , id] , ()=>deleteDevices(id),{
    onSuccess:(data)=>{
     toast.success(`${data.message}`)
     refetch()
  
    },
    onError:(error)=>{
      toast.error(`${error.data.response.message}`)
    }
  })

  const deletePost =()=>{
    mutation.mutate()
  }
  return (
    <tr>
      <td className={classes.idTable}>{id}</td>
      <td><b>{name} #{id}</b> <br></br>{branch}</td>
      <td>{mac}</td>
      <td>{uuid}</td>  
      <td>{status}</td>   
      <td>
        <div>
          <div role="group" class="btn-group">
            <button
              class="btn btn-success"
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/device/${id}`)
              }>
              <i class="fa fa-eye"></i>
            </button>
            <button
              class="btn btn-secondary"
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/devicesupdate/${id}`)
              }>
              <EditPen />
            </button>
            <button class="btn btn-danger" onClick={deletePost}>
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </td>
      
    </tr>
  );
};

export default SingleDevice;
